import get from 'lodash.get';

import React from "react";
import BatchPrint from "../BatchPrint";

import { fetchReport as fetchProgressReport } from "../../services/progress";
import ProgressReportBatchPrintRenderer from './ProgressReportBatchPrintRenderer';

// Batch Print for Parent Report

export default function ProgressReportBatchPrint() {
  return (
    <BatchPrint
      title="Progress Report"
      getStudentData={getStudentData}
      renderReport={(report, i) => <ProgressReportBatchPrintRenderer report={report} i={i}/> }
      />
  );

  async function getStudentData(student, selections) {
    const { metric, scale, benchmark, customBenchmarks, equating, locale, selectedStatePercentileCuts } =
      selections;

    const [progressReport] = await 
      fetchProgressReport(
        student,
        metric.value,
        scale.value,
        benchmark,
        customBenchmarks,
        equating,
        locale,
        {skipARM: false},
        selectedStatePercentileCuts
      );
    return { student, progressReport };
  }
}